import { Menu } from "lucide-react";
import { cn } from "~/lib/utils";
import { AppSidebar } from "./sidebar";
import { SidebarProvider, useSidebar } from "./sidebar-context";

interface AppLayoutProps {
	title?: string;
	titleActions?: React.ReactNode;
	children: React.ReactNode;
}

function AppLayoutInner({ title, titleActions, children }: AppLayoutProps) {
	const { toggle } = useSidebar();

	return (
		<div className="flex min-h-screen">
			<AppSidebar />
			<main id="main-content" className="flex-1 overflow-auto md:ml-64">
				<div
					className={cn(
						"flex flex-wrap items-center justify-between gap-2 border-b border-gray-200 bg-white px-4 py-3 md:px-8 md:py-4",
						!title && "md:hidden",
					)}
				>
					<div className="flex items-center gap-3">
						<button
							type="button"
							onClick={toggle}
							aria-label="Otevřít menu"
							className="flex h-9 w-9 items-center justify-center rounded-lg text-muted hover:bg-gray-100 hover:text-text transition-colors md:hidden"
						>
							<Menu className="h-5 w-5" />
						</button>
						{title && <h1 className="text-lg font-semibold">{title}</h1>}
					</div>
					{title && titleActions}
				</div>
				<div className="p-4 md:p-8">{children}</div>
			</main>
		</div>
	);
}

export function AppLayout(props: AppLayoutProps) {
	return (
		<SidebarProvider>
			<AppLayoutInner {...props} />
		</SidebarProvider>
	);
}
